export default "__VITE_ASSET__BmI0FGgv__"